export default __webpack_public_path__ + "static/media/Alex.7528362c.jpg";